<script setup lang="ts">
import { computed } from 'vue'
import { AccordionHeader, AccordionTrigger, type AccordionTriggerProps } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<AccordionTriggerProps & { class?: string } & { arrowStyle?: string }>()

const delegatedProps = computed(() => {
    const { class: _, arrowStyle, ...delegated } = props

    return delegated
})
</script>

<template>
    <AccordionHeader class="flex">
        <AccordionTrigger
            v-bind="delegatedProps"
            :class="
                cn(
                    'flex flex-1 items-center justify-between transition-all [&[data-state=open]>span.v-icon]:rotate-180 cursor-pointer',
                    props.class,
                )
            "
        >
            <slot />
            <slot name="icon">
                <VIcon
                    name="chevron-down"
                    size="s"
                    class="v-icon transition-transform duration-400"
                />
            </slot>
        </AccordionTrigger>
    </AccordionHeader>
</template>
